import { render, staticRenderFns } from "./NotificationsModal.vue?vue&type=template&id=6d5f4b6d&"
import script from "./NotificationsModal.vue?vue&type=script&lang=js&"
export * from "./NotificationsModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports